import axios from "axios";
import type { ErrorEvent as SentryErrorEvent, EventHint } from "@sentry/vue";

/**
 * Sentry `beforeSend` hook.
 *
 * A 403 is an expected authorization outcome (e.g. the granular-permission checks
 * MenuSidebar runs via enforce.ts/getCountries), not a real error. Downgrading these
 * unhandled AxiosError rejections to warnings stops them polluting Sentry as errors,
 * while keeping them visible for debugging. All other events pass through unchanged.
 */
export function downgradeForbiddenToWarning(event: SentryErrorEvent, hint: EventHint): SentryErrorEvent {
    const error = hint?.originalException;
    if (axios.isAxiosError(error) && error.response?.status === 403) {
        event.level = "warning";
    }
    return event;
}
